module.exports = __webpack_public_path__ + "img/icon_drop_down.2bbb51b9.svg";